import React from 'react';
import {Stack, Box} from '@mui/material';
import {ResultType, SessionSearch} from '../types/SessionSearch';
import {isExecuted} from '../utilities/utilities';
import QueryHeader from './query-header/QueryHeader';
import QuerySubheader from './query-subheader/QuerySubheader';
import QueryList from './query-list/QueryList';
import QuerySearchCriteria from './query-search-criteria/QuerySearchCriteria';
import QueryResults from './query-results/QueryResults';

export interface SearchQueryProps {
  userRoleId: number;
  item: SessionSearch;
  canEdit?: boolean;
  onCopy?: (item: SessionSearch) => void;
  onSave?: (item: SessionSearch) => void;
  onSearch?: (item: SessionSearch) => void;
  onModify?: (item: SessionSearch) => void;
  onAddContentAndMetadataQuery?: (item: SessionSearch) => void;
  onAddConceptualQuery?: (item: SessionSearch) => void;
  onAddWorkProductQuery?: (item: SessionSearch) => void;
  onAddAnalyticsQuery?: (item: SessionSearch) => void;
  onQueryReordered?: (item: SessionSearch) => void;
  onQueryDeleted?: (item: SessionSearch) => void;
  onQueryModified?: (item: SessionSearch) => void;
  OnAddToShoppingCart?: (type: ResultType) => boolean;
}

const SearchQuery: React.FC<SearchQueryProps> = (props) => {
  const {item, canEdit = false} = props;

  const isEditMode = () => {
    if (canEdit) {
      // Parent component override
      return true;
    }

    if (!isExecuted(item)) {
      // Unexecuted searches are editable
      return true;
    }

    return false;
  };

  const renderEditableSearch = () => {
    return (
      <Stack className="session-search-query session-search-query--edit">
        <Box className="session-search-query-header-panel">
          <QueryHeader {...props} />
        </Box>
        <Box className="session-search-query-subheader-panel">
          <QuerySubheader {...props} />
        </Box>
        <Box className="session-search-query-list-panel">
          <QueryList {...props} />
        </Box>
      </Stack>
    );
  };

  const renderReadonlySearch = () => {
    return (
      <Stack className="session-search-query session-search-query--read-only">
        <Box className="session-search-query-header-panel">
          <QueryHeader {...props} />
        </Box>
        <Box className="session-search-query-list-panel">
          <QuerySearchCriteria {...props} />
        </Box>
        <Box className="session-search-query-results-panel">
          <QueryResults {...props} />
        </Box>
      </Stack>
    );
  };

  if (isEditMode()) {
    return renderEditableSearch();
  } else {
    return renderReadonlySearch();
  }
};

export default SearchQuery;
